import { render } from "./block_whatsapp.vue?vue&type=template&id=317c6e74"
import script from "./block_whatsapp.vue?vue&type=script&lang=js"
export * from "./block_whatsapp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__